import React from 'react';
import { compose, lifecycle, withState, withHandlers, withProps } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
import AddValueForm from './form/addValueForm';
import { addAttributeValue, getAttribute } from './_api';
import { withSnackbar } from 'notistack';
import { get } from 'lodash';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 20,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});

const enhance = compose(
  withStyles(styles),
  withSnackbar,
  withLoader,
  withRouter,
  withProps(({ match: { params: { id } }, addAttribute }) => ({
    attributeId: id,
  })),
  withState('attribute', 'setAttribute', null),
  lifecycle({
    async componentDidMount() {
      const { attributeId, setAttribute, toggleLoader } = this.props;
      toggleLoader();
      const resp = await getAttribute(attributeId);
      if (resp) {
        setAttribute(resp);
      }
      toggleLoader(false);
    },
  }),
  withHandlers({
    onSubmit: ({ history, toggleLoader, attributeId, enqueueSnackbar }) => async values => {
      toggleLoader();
      const resp = await addAttributeValue(attributeId, values);
      if (get(resp, 'success', false)) {
        enqueueSnackbar('Hodnota k atributě úspěšně uložena.', { variant: 'success' });
        history.push(`/attributes/${attributeId}`);
      } else {
        enqueueSnackbar('Hodnota k atributě se nepodařila uložit.', { variant: 'error' });
      }
      toggleLoader(false);
    },
  }),
);

export default enhance(({ classes, attribute, onSubmit }) => (
  <div className={classes.root}>
    <h2>
      Přidat hodnotu pro atribut: <b>{get(attribute, 'name', '')}</b>
    </h2>
    <Paper className={classes.paper}>
      <AddValueForm onSubmit={onSubmit} />
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/attributes/addValue.js